type ApiErrorResponse<T> = {
  status: number
  data: T | undefined
}

type ApiErrorResponseWithErrorCode<T> = {
  status: number
  data: T & { errorCode: string }
}

export const isValidApiResponse = <T extends object>(
  error: unknown,
): error is ApiErrorResponse<T> => {
  return (
    typeof error === 'object' &&
    error !== null &&
    'status' in error &&
    Boolean(error.status) &&
    'data' in error
  )
}

export const isApiErrorResponseWithErrorCode = <T extends object>(
  error: unknown,
): error is ApiErrorResponseWithErrorCode<T> => {
  return (
    isValidApiResponse(error) &&
    error.status >= 400 &&
    error.data !== undefined &&
    Object.prototype.hasOwnProperty.call(error.data, 'errorCode')
  )
}
